// extracted by mini-css-extract-plugin
export var formContainer = "_le-0";
export var message = "_le-1";